<div class="product-card grow fill flex flex--column relative elevation-level-1 rounded-large overflow-hidden">
  @if (useNewProductCardLayout()) {
    <div class="surface-primary">
      <div class="flex" [class.flex--column]="!isLaptopUp()" data-testid="product-card-content-container">
        @if (image()) {
          <div
            class="relative flex flex--shrink0 overflow-hidden nordic-blue-900-bg"
            [class.product-card-image-wide]="isLaptopUp()"
          >
            <fcom-image
              class="picture block flex--self-stretch"
              [imageData]="image()"
              [ratio]="isLaptopUp() ? '16x9' : '21x9'"
              [scale]="false"
              [fillParent]="isLaptopUp()"
            />
          </div>
        }
        <div class="flex-1 flex flex--column ps-medium-y pr-xsmall-x">
          <div class="flex flex--space-between">
            <h2 class="font-title-medium" data-testid="product-card-title">
              {{ title() }}
            </h2>
            @if (lowQuota()) {
              <div
                data-testid="product-card-quota"
                class="flex flex--middle flex--shrink0 flex--self-start g-xxsmall ps-small-l"
              >
                <span class="font-label-small">{{ lowQuota().segment | uppercase }}</span>
                <fcom-tag data-testid="product-card-quota-tag" class="flex--self-center">
                  {{ 'ancillaries.quota.quotaLeft' | finPluralLocalization: lowQuota().count : 'quota' }}
                </fcom-tag>
              </div>
            }
          </div>
          @if (showDetailText() && detailText()) {
            <p class="font-body-medium" data-testid="product-card-detail-text">{{ detailText() }}</p>
          }
          @if (productTags().length && !countText()) {
            <div class="flex g-xxsmall flex--wrap ps-xsmall-t" data-testid="product-card-tags-column">
              @for (productTag of productTags(); track $index) {
                <fcom-tag data-testid="product-card-product-tag" [theme]="productTag.theme">
                  @if (productTag.icon) {
                    <fcom-icon class="icon-small" [name]="productTag.icon" />
                  }
                  <span class="overflow-hidden truncate" [class.ms-xxsmall-l]="productTag.icon">{{
                    productTag.localizationKey | finLocalization: productTag.localizationParams
                  }}</span>
                </fcom-tag>
              }
            </div>
          }

          <div class="flex-1 flex flex--row flex--space-between ps-xlarge-t" data-testid="product-card-actions">
            <div class="flex-1 flex flex--column flex--self-end">
              @if (!countText()) {
                @if (lowestPrice() || originalPrice()) {
                  <div class="flex flex--middle font-body-small">
                    @if (originalPrice()) {
                      <div>
                        <span data-testid="product-card-starting-from-label">{{
                          'localSettings.ancillaries.productCard.originalPriceLabel' | finLocalization
                        }}</span>
                        <span class="strike-through ps-xxsmall-l" data-testid="product-card-original-price">{{
                          originalPrice()
                        }}</span>
                      </div>
                    } @else {
                      <span data-testid="product-card-starting-from-label">{{
                        'pricesStartingFrom' | finLocalization
                      }}</span>
                    }
                  </div>
                  @if (lowestPrice()) {
                    <div class="flex flex--middle">
                      <span
                        class="font-title-medium heather-700-text text-icon-primary"
                        data-testid="product-card-price"
                        >{{ lowestPrice() }}</span
                      >
                      @if (aviosLowestPrice()) {
                        <span
                          class="nowrap ps-xxsmall-l flex flex--middle font-label-medium"
                          data-testid="product-card-avios-price"
                        >
                          /
                          <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                          {{ aviosLowestPrice() }}
                          {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                        </span>
                      }
                    </div>
                  }
                }
              }
            </div>
            <div class="flex--self-end" data-testid="cta-button-container">
              @if (!hideButton()) {
                <fcom-button
                  class="block"
                  [mode]="ButtonMode.INLINE"
                  [loading]="loading()"
                  [theme]="buttonTheme()"
                  [text]="buttonText()"
                  [icon]="{ name: buttonIcon(), position: buttonIconPosition() }"
                  [title]="buttonAriaText()"
                  [aria]="{
                    label: buttonAriaText(),
                    role: 'button',
                    loadingLabel: 'actions.loading' | finLocalization,
                  }"
                  [focusOnRender]="focusOnBtn()"
                  (clickBtn)="emitProductCategory($event)"
                />
              }
            </div>
          </div>
        </div>
      </div>

      @if (countText()) {
        <div class="border-top ps-xsmall-y pr-small-x flex font-body-medium-bold" data-testid="product-card-count-text">
          <span>{{ countText() }}: {{ price() }}</span>
          @if (aviosPrice()) {
            <span class="ps-xxsmall-l flex flex--middle font-label-medium" data-testid="product-card-avios-price">
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosPrice() | finMap: 'amount' | finPoints }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>
      }

      @if (notificationText()) {
        <fcom-notification
          class="border-top"
          [attr.data-testid]="'product-card-notification'"
          [theme]="notificationTheme()"
          [layout]="NotificationLayout.EDGE_TO_EDGE"
          [title]="notificationTitle()"
          [iconName]="notificationIcon()"
          [removeHorizontalPadding]="true"
        >
          <p [innerHTML]="notificationText() | finSafe: 'html'"></p>
        </fcom-notification>
      }
    </div>
  } @else {
    @if (image()) {
      <fcom-image class="picture block rounded-top-large" [ratio]="'21x9'" [imageData]="image()" />
    }

    <div
      class="flex-1 ps-medium white-bg surface-primary flex flex--column"
      [class.rounded-bottom-large]="!!image()"
      [class.rounded-large]="!image()"
    >
      <div class="flex flex--space-between flex--wrap g-xsmall">
        <h2 class="nordic-blue-900-text text-icon-primary font-title-medium">{{ title() }}</h2>
        @if (lowQuota()) {
          <div data-testid="product-card-quota" class="flex flex--middle g-xxsmall">
            <span class="font-label-small">{{ lowQuota().segment | uppercase }}</span>
            <fcom-tag data-testid="product-card-quota-tag" class="flex--self-center">
              {{ 'ancillaries.quota.quotaLeft' | finPluralLocalization: lowQuota().count : 'quota' }}
            </fcom-tag>
          </div>
        }
      </div>

      @if (lowestPrice()) {
        <div class="flex flex--middle">
          <span class="ps-xxsmall-r font-body-small" data-testid="product-card-starting-from-label">{{
            'pricesStartingFrom' | finLocalization
          }}</span>
          <span
            [ngClass]="{
              'font-title-medium': !originalPrice(),
              'strike-through': originalPrice(),
              'font-body-small': originalPrice(),
            }"
            data-testid="product-card-starting-from-price"
            >{{ originalPrice() ? originalPrice() : lowestPrice() }}</span
          >
          @if (originalPrice()) {
            <span
              class="heather-700-text text-icon-primary ps-xxsmall-l font-title-medium"
              data-testid="product-card-discounted-price"
              >{{ lowestPrice() }}</span
            >
          }
          @if (aviosLowestPrice()) {
            <span class="ps-xxsmall-l flex flex--middle font-label-medium" data-testid="product-card-avios-price">
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosLowestPrice() }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>
      }

      @if (productTags().length) {
        <fcom-tag data-testid="product-card-product-tag" [theme]="productTags()[0].theme">
          @if (productTags()[0]?.icon) {
            <fcom-icon class="icon-small" [name]="productTags()[0].icon" />
          }
          <span [class.ms-xxsmall-l]="productTags()[0]?.icon">{{
            productTags()[0].localizationKey | finLocalization: productTags()[0].localizationParams
          }}</span>
        </fcom-tag>
      }

      @if (detailText()) {
        <p class="ps-xsmall-t ps-small-b flex-1 font-body-medium">{{ detailText() }}</p>
      }

      @if (statusText() || purchasedText()) {
        <hr class="border-top-dashed nordic-blue-50-border border-primary" aria-hidden="true" />

        <div class="ps-small-y align-right">
          @if (purchasedText()) {
            <div class="nordic-blue-900-text text-icon-primary font-body-medium">
              {{ purchasedText() }}
            </div>
          }
          <div
            class="font-body-medium"
            data-testid="product-card-status-text"
            [ngClass]="{ 'nordic-blue-900-text text-icon-primary': !hasAddedItems() }"
          >
            {{ statusText() }}
          </div>
          @if (price()) {
            <div class="nordic-blue-900-text text-icon-primary font-body-medium flex flex--middle flex--end">
              {{ price() }}
              @if (aviosPrice()) {
                <span class="ps-xxsmall-l">
                  /
                  <fcom-icon class="icon-small" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                  {{ aviosPrice() | finMap: 'amount' | finPoints }}
                  {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                </span>
              }
            </div>
          }
        </div>

        <hr class="border-top-dashed nordic-blue-50-border border-primary" aria-hidden="true" />
      }

      <div class="align-center">
        @if (!hideButton()) {
          <fcom-button
            class="block ps-small-t"
            [mode]="ButtonMode.FILL"
            [loading]="loading()"
            [theme]="buttonTheme()"
            [text]="buttonText()"
            [icon]="{ name: buttonIcon(), position: IconPosition.RIGHT }"
            [title]="buttonAriaText()"
            [aria]="{ label: buttonAriaText(), role: 'button', loadingLabel: 'actions.loading' | finLocalization }"
            [focusOnRender]="focusOnBtn()"
            (clickBtn)="emitProductCategory($event)"
          />
        }

        @if (notificationText()) {
          <fcom-notification
            class="block ps-small-y ps-small-t align-left"
            [attr.data-testid]="'product-card-notification'"
            [theme]="notificationTheme()"
            [title]="notificationTitle()"
            [iconName]="notificationIcon()"
          >
            {{ notificationText() }}
          </fcom-notification>
        }
      </div>
    </div>
  }
</div>
